import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-below-reserve-bid',
  imports: [FontAwesomeModule, ButtonModule, DialogModule],
  templateUrl: './below-reserve-bid.component.html',
  styleUrl: './below-reserve-bid.component.scss'
})
export class BelowReserveBidComponent {

  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  faCheckCircle = faCheckCircle

  onClose() {
    this.close.emit();
  }
}
